import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BesharpChatComponent, BesharpChatConfig } from '../../modules/besharp-chat/besharp-chat.component';
import { ChatApiService } from '../../services/chat-api.service';

@Component({
  selector: 'app-chat-page',
  imports: [BesharpChatComponent],
  templateUrl: './chat-page.component.html',
  styleUrl: './chat-page.component.scss',
})
export class ChatPageComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected chatApiService = inject(ChatApiService);

  protected chatConfig: BesharpChatConfig = {
    botName: 'Datahub Agent',
    userLabel: 'You',
    placeholder: 'Ask the ITU Datahub Agent…',
    showTimestamps: true,
    emptyState: {
      icon: 'pi pi-globe',
      title: 'ITU Datahub Agent',
      description: 'Start a conversation to get information about ITU',
      suggestions: [
        "What's the latest value for international bandwidth for Africa?",
        'What does the ITU recommend as the minimum age for ICT household surveys?',
      ],
    },
  };

  private paramsSub?: Subscription;

  ngOnInit(): void {
    this.paramsSub = this.route.paramMap.subscribe((params) => {
      const sessionId = params.get('id') ?? undefined;
      this.chatConfig = { ...this.chatConfig, sessionId };
    });
  }

  protected onSessionCreated(sessionId: string): void {
    this.router.navigate(['/app/session', sessionId], { replaceUrl: true });
    this.chatApiService.newSessionCreated$.next(sessionId);
  }

  ngOnDestroy(): void {
    this.paramsSub?.unsubscribe();
  }
}
